import React from "react";
import { Col } from "react-bootstrap";

const RenderInfoData = ({ keyName, colSize, className, ...data }) => {
  return (
    <Col {...colSize} className={className}>
      {data[keyName]}
    </Col>
  );
};

export default RenderInfoData;
